var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerksMascotBirthday(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 187,
    viewBox: "0 0 181 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40.5 0h100v27h-100z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.039 21.755L44.757 5.177c1.701-.43 3.525-.633 5.471-.606 2.933.04 5.384.64 7.351 1.8 1.98 1.16 2.95 2.953 2.91 5.38-.03 1.772-.693 3.143-1.99 4.113-1.296.955-2.824 1.421-4.584 1.398a7.713 7.713 0 01-2.274-.351l.89 4.212-6.492.632zm5.305-8.568c.966-.36 1.753-.79 2.362-1.289.608-.498.919-1.134.932-1.907.009-.533-.19-.956-.599-1.268-.395-.326-.898-.493-1.512-.5a3.72 3.72 0 00-1.103.164l-.08 4.8zm12.86 7.134l-.94-15.494 9.74-1.068.181 3.483-5.17.53.308 3.124 3.364-.194.315 2.644-2.536.926.22 1.203 4.566-.298.249 6.604-10.297-1.46zm13.455 2.262L76.522 5.707c.98-.387 2.145-.691 3.496-.913a22.477 22.477 0 013.906-.307c1.44.02 2.643.202 3.611.549.981.333 1.58.828 1.795 1.484.216.656.319 1.298.308 1.924a4.582 4.582 0 01-.556 2.133c-.344.662-.856 1.335-1.534 2.02l6.28 4.765-6.82 4.688-3.261-7.045-2.224 1.41.583 4.548-4.447 1.62zm4.458-10.58a7.612 7.612 0 002.2-1.13c.648-.485.977-1.034.987-1.647.004-.2-.046-.414-.149-.642-.09-.242-.22-.41-.392-.506a.984.984 0 00-.557-.167c-.413-.006-.936.154-1.568.479l-1.513.76.992 2.853zm14.5 8.757l.62-15.473 6.947.814-1.677 6.938 5.141-5.931 5.757.198-6.714 6.75 6.848 6.693-7.823 1.334-3.873-5.213-1.657 5.738-3.57-1.848zm18.812-1.126l2.99-5.36c.549.688 1.366 1.252 2.452 1.694 1.086.428 2.13.648 3.129.662.694.01 1.242-.083 1.645-.278.404-.194.609-.498.616-.912.015-.906-.686-1.642-2.103-2.208-1.353-.432-2.699-.87-4.039-1.315-1.497-.58-2.275-1.11-2.333-1.592a11.421 11.421 0 01-.063-1.02c.022-1.32.765-2.277 2.228-2.87 1.477-.607 3.09-.966 4.839-1.075 1.762-.123 3.298-.216 4.605-.278l-.059 3.54a16.495 16.495 0 00-1.89-.626c-.637-.182-1.215-.277-1.735-.284-.52-.007-.928.081-1.225.264-.283.183-.428.5-.436.954-.004.213.86.412 2.59.595 1.731.184 3.229.71 4.494 1.581 1.279.87 1.899 2.493 1.859 4.866-.035 2.093-.95 3.76-2.745 5.003-1.781 1.243-3.845 1.848-6.191 1.816-1.96-.026-3.59-.255-4.889-.686-1.3-.43-2.546-1.255-3.739-2.47z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-perks-mascot-birthday_svg__clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.937 160.425a.807.807 0 01-.803-.802v-14.477a.828.828 0 01.73-.808 14.825 14.825 0 009.366-4.85 14.781 14.781 0 000-19.689 14.82 14.82 0 00-9.365-4.85.833.833 0 01-.731-.808V99.664a.808.808 0 01.803-.802h94.229a.812.812 0 01.81.802v14.477a.843.843 0 01-.731.808 14.81 14.81 0 00-9.396 4.834 14.772 14.772 0 000 19.72 14.811 14.811 0 009.396 4.835.83.83 0 01.731.808v14.477a.815.815 0 01-.239.568.812.812 0 01-.571.234H40.937z",
    fill: "#FFEC0F",
    stroke: "#000",
    strokeWidth: 3.704,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.025 129.643c15.433 1.056 29.338 6.153 34.37-13.729",
    stroke: "#000",
    strokeWidth: 3.704,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.334 117.079c-1.812-9.109-.036-13.874 3.624-13.175 4.627.766 2.978 6.624-3.624 13.175z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 2.511,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.082 112.066a.109.109 0 010 .145h-.036l-1.208.699c-.438.23-.89.431-1.353.604-.737-.441-2.277-5.49-1.812-6.033-.036-.036 0-.114.036-.15.036-.037.109 0 .151.036l2.012 2.202 2.21 2.497z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 2.511,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.525 130.011c-20.966-.548-23.896 17.97-20.743 32.942",
    stroke: "#000",
    strokeWidth: 3.704,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.378 159.985c5.206 7.691 5.436 12.74 1.812 13.548-4.488 1.098-5.292-4.946-1.812-13.548z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 2.511,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.973 166.668c-.072-.036-.072-.072-.036-.144v-.037l.846-1.097c.3-.403.645-.771 1.026-1.098.84.108 4.229 4.168 4.03 4.789a.097.097 0 01-.037.151.065.065 0 01-.054.028.065.065 0 01-.055-.028l-2.675-1.249-3.045-1.315z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 2.511,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.813 161.342c-3.298 6.515-3.298 13.765-2.198 22.367M105.798 161.342c4.766 6.515 4.766 13.765 3.153 22.367",
    stroke: "#000",
    strokeWidth: 3.704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.127 182.72c-3.449-1.81-6.783-1.719-9.936.603a.937.937 0 00-.343.986.936.936 0 00.162.329.828.828 0 00.767.368c2.754-.072 3.775-.181 9.09-.802a.788.788 0 00.701-.845.915.915 0 00-.44-.639zM108.873 182.647c3.267-2.159 6.565-2.455 9.936-.476a.947.947 0 01.332 1.279.888.888 0 01-.737.44c-2.748.217-3.775.217-9.127.145a.796.796 0 01-.552-.241.781.781 0 01-.215-.561.844.844 0 01.363-.586z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 2.511,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.33 139.234c6.269 4.464 11.88 3.988 16.912 0",
    stroke: "#000",
    strokeWidth: 3.704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.695 120.969c-1.063.477-2.162 1.719-1.812 3.016.35 1.297 1.172 1.502 2.53 1.647 1.36.145 3.118.042 3.226.332.109.289 0 .694-1.286 1.025-1 .247-2.05.197-3.02-.144-.26-.187-.369-.187-.441-.115-.296.223-.478.603-.514 1.429-.036.827 1.063 1.466 3.262 1.539a8.32 8.32 0 00-.29 1.538c-.151 1.279 1.498 1.206 1.866 1.17.369-.036.296-1.098.369-1.351a8.008 8.008 0 00-.073-1.502 6.334 6.334 0 003.075-1.719c.737-.917.187-2.636-.803-3.3-1.25-.838-4.513-.603-4.513-.947s.224-.603 1.504-1.134c2.127-.953 3.19-.404 3.335-.7.145-.295.223-.603-.29-1.206a2.16 2.16 0 00-1.945-.844c-.283.03-.564.08-.84.15.038-.602.038-1.207 0-1.809 0-.398-1.1-.29-1.359-.398a.595.595 0 00-.478.051.59.59 0 00-.289.383c.006.806.054 1.612.145 2.413-.462.133-.916.292-1.36.476zM101.141 120.969c-1.063.477-2.162 1.719-1.812 3.016.35 1.297 1.172 1.502 2.489 1.647 1.317.145 3.117.042 3.225.332.109.289 0 .694-1.28 1.025-1 .246-2.049.195-3.02-.144-.254-.187-.363-.187-.441-.115-.29.223-.472.603-.514 1.43-.042.826 1.063 1.465 3.268 1.538a7.813 7.813 0 00-.296 1.538c-.145 1.279 1.504 1.206 1.866 1.17.363-.036.296-1.098.369-1.351a7.941 7.941 0 00-.073-1.502 6.357 6.357 0 003.081-1.719c.731-.917.181-2.636-.809-3.3-1.245-.838-4.507-.603-4.507-.947s.218-.603 1.505-1.134c2.126-.953 3.189-.404 3.334-.7.145-.295.217-.603-.296-1.206a2.155 2.155 0 00-1.939-.844c-.285.03-.568.08-.846.15.038-.602.038-1.207 0-1.809 0-.398-1.099-.29-1.353-.398a.603.603 0 00-.773.434c.006.806.054 1.612.145 2.413-.449.134-.891.293-1.323.476z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.798 66.367l5.557 16.226 5.557 16.232H76.689l5.558-16.232 5.55-16.226z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3.704,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.797 67.995a3.875 3.875 0 003.878-3.872 3.875 3.875 0 00-3.878-3.873 3.875 3.875 0 00-3.878 3.873 3.875 3.875 0 003.878 3.872zM82.923 80.62l8.492-3.691 2.217 6.472-14.122 7.19 3.413-9.97zM95.68 89.385l-16.17 8.928h19.226l-3.056-8.928zM27.327 91.816a6.198 6.198 0 01-6.42-.03c-10.988-6.738-19.166-15.14-18.49-28.4a21.634 21.634 0 016.35-15.308 21.694 21.694 0 0115.329-6.34c5.75 0 11.263 2.28 15.329 6.34a21.634 21.634 0 016.35 15.309c.503 11.203-5.646 20.68-18.448 28.429z",
    fill: "#FFEC0F",
    stroke: "#000",
    strokeWidth: 3.704,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.09 94.573l1.081 1.87 1.081 1.87h-4.318l1.08-1.87 1.076-1.87z",
    fill: "#FFEC0F",
    stroke: "#000",
    strokeWidth: 2.511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.084 98.313c1.987 13.077.659 16.19-1.262 26.692-2 10.966-5.153 25.871 9.06 44.318",
    stroke: "#000",
    strokeWidth: 3.704,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.16 108.157h-22.102a1.49 1.49 0 01-1.485-1.339l-1.48-14.157a1.495 1.495 0 011.486-1.647h25.037a1.495 1.495 0 011.415 1.031c.065.199.087.408.065.616l-1.474 14.157a1.488 1.488 0 01-1.462 1.339z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3.704,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.136 83.781h-22.047a3.604 3.604 0 00-3.607 3.602v.006a3.604 3.604 0 003.607 3.6h22.047a3.604 3.604 0 003.606-3.6v-.006a3.604 3.604 0 00-3.606-3.602z",
    fill: "#FFEC0F",
    stroke: "#000",
    strokeWidth: 3.704,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.378 76.573h-14.527a3.604 3.604 0 00-3.606 3.601v.006a3.604 3.604 0 003.606 3.601h14.527a3.603 3.603 0 003.606-3.6v-.007a3.603 3.603 0 00-3.606-3.601z",
    fill: "#FFEC0F",
    stroke: "#000",
    strokeWidth: 3.704,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.555 65.77h-2.887a1.43 1.43 0 00-1.432 1.43v7.943c0 .79.641 1.43 1.432 1.43h2.887a1.43 1.43 0 001.432-1.43V67.2c0-.79-.641-1.43-1.432-1.43z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3.704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.482 62.856c0 1.61-1.51 2.914-3.37 2.914-1.861 0-3.371-1.303-3.371-2.914v-.26a12.97 12.97 0 013.359-8.082c1.987 1.73 2.881 4.506 3.298 7.733l.084.61z",
    fill: "#FFEC0F",
    stroke: "#000",
    strokeWidth: 3.704,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.112 42.866v-3.988M172.15 48.44l3.323-3.318M149.796 48.524l-3.48-3.48M146.853 61.046h-5.605M173.938 61.046h4.682",
    stroke: "#000",
    strokeWidth: 3.704,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-perks-mascot-birthday_svg__clip0_0_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 37)",
    d: "M0 0h180v149.63H0z"
  })))));
}
export default SvgIconPerksMascotBirthday;